export function ColorDot({ color = '#1abc9c' }) {
    return <div style={{ width: 8, height: 8, borderRadius: 4, backgroundColor: color }} />;
}